import React from 'react';
import FilterEditorContainer from './FilterEditorContainer';
import {FormattedMessage} from 'react-intl';
import FilterGroupValueMessage from 'components/FilterGroupValueMessage';
import FilterEditorStep from './FilterEditorStep';
import FilterGroupEditorModal from './FilterGroupEditorModal';

class FilterGroupEditor extends React.Component {
  constructor() {
    super(...arguments);
    this.handleApplyClick = this.handleApplyClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleValueClick = this.handleValueClick.bind(this);
    this.handleRequestModalClose = this.handleRequestModalClose.bind(this);
    this.state = {
      isOpen: false,
      selectedFilterGroupIds: new Set(this.props.selectedFilterGroupIds),
    };
  }

  handleApplyClick() {
    this.props.onApply([...this.state.selectedFilterGroupIds]);
  }

  handleValueClick() {
    this.setState({isOpen: true});
  }

  handleRequestModalClose() {
    this.setState({isOpen: false});
  }

  handleSelect(filterGroupId) {
    const selectedFilterGroupIds = new Set(this.state.selectedFilterGroupIds);

    if (selectedFilterGroupIds.has(filterGroupId)) {
      selectedFilterGroupIds.delete(filterGroupId);
    } else {
      selectedFilterGroupIds.add(filterGroupId);
    }

    this.setState({selectedFilterGroupIds});
  }

  render() {
    const {filterGroups} = this.props;
    const {selectedFilterGroupIds, isOpen} = this.state;

    return (
      <FilterEditorContainer
        canRemove={false}
        canApply={selectedFilterGroupIds.size > 0}
        onApply={this.handleApplyClick}
      >
        <FilterEditorStep>
          <div className="FilterEditor__StepTitle">
            <FormattedMessage
              id="FilterGroupEditor__FilterByTitle"
              description="Title for Filter By step in PDP policy picker"
              defaultMessage="Filter By"
            />
          </div>
          <div className="FilterEditor__StepValue">
            <FormattedMessage
              id="FilterGroupEditor__FilterByValue"
              description="Value of the &quot;Filter By&quot; step for PDP policies"
              defaultMessage="PDP Policy"
            />
          </div>
        </FilterEditorStep>
        <FilterEditorStep>
          <div className="FilterEditor__StepTitle">
            <FormattedMessage
              id="FilterGroupEditor__OperandTitle"
              description="Title for the operand step in PDP policy picker"
              defaultMessage="Operator"
            />
          </div>
          <div className="FilterEditor__StepValue">
            <FormattedMessage
              id="FilterGroupEditor__OperandValue"
              description="Value for the operand step in PDP policy picker"
              defaultMessage="In"
            />
          </div>
        </FilterEditorStep>
        <FilterEditorStep selected={true} onClick={this.handleValueClick}>
          <div className="FilterEditor__StepTitle">
            <FormattedMessage
              id="FilterGroupEditor__ValueTitle"
              description="Title for the value step in PDP policy picker"
              defaultMessage="Value"
            />
          </div>
          <div className="FilterEditor__StepValue">
            <FilterGroupValueMessage
              totalCount={filterGroups.length}
              enabledCount={selectedFilterGroupIds.size}
            />
          </div>
        </FilterEditorStep>
        <FilterGroupEditorModal
          filterGroups={filterGroups}
          selectedFilterGroupIds={selectedFilterGroupIds}
          isOpen={isOpen}
          onSelect={this.handleSelect}
          onRequestModalClose={this.handleRequestModalClose}
        />
      </FilterEditorContainer>
    );
  }
}
export default FilterGroupEditor;
